import React from "react";

interface RenderStatusProps {
  label: string;
  texto?: string;
  cor?: string;
}

const RenderStatus: React.FC<RenderStatusProps> = ({ label, texto, cor }) => {
  return (
    <div style={{ marginTop: 5, marginBottom: 5 }}>
      <b
        style={{
          color: cor,
        }}
      >
        {label}
      </b>
      <br />
      {texto && texto}
    </div>
  );
};

interface RenderChamadoProps {
  contato_ok: number;
  chamado: number;
  chamadotexto?: string;
  contato_recado: number;
  contato_recadotexto?: string;
  contato_natende: number;
  contato_email: number;
  contato_whats: number;
  contato_sms: number;
  contato_stelefone: number;
  contato_trabalhando: number;
  contato_semperfil: number;
  contato_sinteresse: number;
  contato_preentre: number;
}

interface RenderEntrevistaProps {
  entrevista_pessoal: number;
  entrevista_telefone: number;
  entrevista_video: number;
  aprovado: number;
  enviado: number;
  contato_standby: number;
  entrevista_semperfil: number;
  entrevista_msemperfil: string;
  contratadodireto: number;
  entrevista_sinteresse: number;
  entrevista_msinteresse: string;
  entrevista_disistiu: number;
  entrevista_mdisistiu: string;
}

interface RenderClientProps {
  analise_ent_aprov: number;
  analise_ean: number;
  analise_motncomp: number;
  aprovadocli?: number;
  naprovadocli?: number;
  mobscli?: string;
  emanalisecli?: number;

  analise_ent_teste?: number;
  analise_obs?: string;
  analise_dt_teste?: string;
  analise_hora?: string;

  analise_ent_naprov?: number;
  analise_motiivonaprov?: string;
}

export const RenderEntrevista: React.FC<RenderEntrevistaProps> = ({
  entrevista_pessoal,
  entrevista_telefone,
  entrevista_video,
  aprovado,
  enviado,
  contato_standby,
  entrevista_semperfil,
  entrevista_msemperfil,
  contratadodireto,
  entrevista_sinteresse,
  entrevista_msinteresse,
  entrevista_disistiu,
  entrevista_mdisistiu,
}) => {
  let status = null;

  if (
    entrevista_pessoal == 1 ||
    entrevista_telefone == 1 ||
    entrevista_video == 1
  ) {
    const statusList: JSX.Element[] = [];

    // PRIMEIRO: Status principais (ordem do modal)
    if (entrevista_pessoal == 1) {
      statusList.push(<RenderStatus label="Pessoal" />);
    }
    if (entrevista_telefone == 1) {
      statusList.push(<RenderStatus label="Telefone" />);
    }
    if (entrevista_video == 1) {
      statusList.push(<RenderStatus label="Vídeo" />);
    }

    // SEGUNDO: Status da área de opções (ordem do modal)
    if (aprovado == 1) {
      statusList.push(<RenderStatus label="Aprovado" />);
    }
    if (enviado == 1) {
      statusList.push(<RenderStatus label="Enviado" />);
    }
    if (contato_standby == 1) {
      statusList.push(<RenderStatus label="Standby" />);
    }
    if (contratadodireto == 1) {
      statusList.push(<RenderStatus label="Contratado Direto" />);
    }
    if (entrevista_sinteresse == 1) {
      statusList.push(
        <RenderStatus label="Sem Interesse" texto={entrevista_msinteresse} />
      );
    }
    if (entrevista_disistiu == 1) {
      statusList.push(
        <RenderStatus label="Desistiu" texto={entrevista_mdisistiu} />
      );
    }
    if (entrevista_semperfil == 1) {
      statusList.push(
        <RenderStatus label="Sem Perfil" texto={entrevista_msemperfil} />
      );
    }

    // Se há múltiplos status, exibir todos
    if (statusList.length > 0) {
      status = (
        <div>
          {statusList.map((statusItem, index) => (
            <div key={index}>{statusItem}</div>
          ))}
        </div>
      );
    } else {
      status = <RenderStatus label="Entrevistado" />;
    }
  } else {
    status = <RenderStatus label="" />;
  }

  // Caso nenhum dos status seja atendido, retorna um componente vazio
  return status;
};

export const RenderCliente: React.FC<RenderClientProps> = ({
  analise_ent_aprov,
  analise_ean,
  analise_motncomp,
  aprovadocli,
  naprovadocli,
  mobscli,
  emanalisecli,

  analise_ent_teste,
  analise_obs,
  analise_dt_teste,
  analise_hora,

  analise_ent_naprov,
  analise_motiivonaprov,
}) => {
  let status = null;

  if (
    analise_ent_aprov == 1 ||
    analise_ean == 1 ||
    analise_motncomp == 1 ||
    aprovadocli == 1 ||
    naprovadocli == 1 ||
    analise_ent_naprov == 1 ||
    emanalisecli == 1
  ) {
    const statusList: JSX.Element[] = [];

    // PRIMEIRO: Status do Currículo do Candidato (ordem do modal)
    if (aprovadocli == 1) {
      statusList.push(
        <RenderStatus
          key="aprovado_curriculo"
          label="Aprovado (Currículo)"
          cor="green"
        />
      );
    }
    if (emanalisecli == 1) {
      statusList.push(
        <RenderStatus
          key="em_analise_curriculo"
          label="Em Análise (Currículo)"
          cor="#ffc100"
        />
      );
    }
    if (naprovadocli == 1) {
      statusList.push(
        <RenderStatus
          key="nao_aprovado_curriculo"
          label="Não Aprovado (Currículo)"
          texto={mobscli}
          cor="red"
        />
      );
    }

    // SEGUNDO: Status da Entrevista do Candidato (ordem do modal)
    if (analise_ent_aprov == 1) {
      statusList.push(
        <RenderStatus
          key="aprovado_entrevista"
          label="Aprovado (Entrevista)"
          cor="green"
        />
      );
    }
    if (analise_ent_naprov == 1) {
      statusList.push(
        <RenderStatus
          key="nao_aprovado_entrevista"
          label="Não Aprovado (Entrevista)"
          texto={analise_motiivonaprov}
          cor="red"
        />
      );
    }
    if (analise_ean == 1) {
      statusList.push(
        <RenderStatus
          key="em_analise_entrevista"
          label="Em Análise (Entrevista)"
          cor="#ffc100"
        />
      );
    }
    if (analise_motncomp == 1) {
      statusList.push(
        <RenderStatus
          key="nao_compareceu"
          label="Não Compareceu (Entrevista)"
          cor="red"
        />
      );
    }

    // Se há múltiplos status, exibir todos
    if (statusList.length > 0) {
      status = (
        <div>
          {statusList.map((statusItem, index) => (
            <div key={index}>{statusItem}</div>
          ))}
        </div>
      );
    }
  } else {
    status = <RenderStatus label="Nenhum Retorno" />;
  }

  // Caso nenhum dos status seja atendido, retorna um componente vazio
  return status;
};

const RenderChamado: React.FC<RenderChamadoProps> = ({
  contato_ok,
  chamado,
  chamadotexto,
  contato_recado,
  contato_recadotexto,
  contato_natende,
  contato_email,
  contato_whats,
  contato_sms,
  contato_stelefone,
  contato_trabalhando,
  contato_semperfil,
  contato_sinteresse,
  contato_preentre,
}) => {
  let status = null;

  if (chamado === 1) {
    if (contato_sms === 1) {
      status = <RenderStatus label="SMS" />;
    } else if (contato_whats === 1) {
      status = <RenderStatus label="WhatsApp" />;
    } else if (contato_email === 1) {
      status = <RenderStatus label="E-mail" />;
    } else if (contato_natende === 1) {
      status = <RenderStatus label="Não Atende" />;
    } else if (contato_recado === 1) {
      status = <RenderStatus label="Recado" texto={contato_recadotexto} />;
    } else if (contato_ok === 1) {
      status = <RenderStatus label="Chamado" texto={chamadotexto} />;
    }
  } else if (contato_preentre === 1) {
    console.log("aqui");
    if (contato_sinteresse === 1) {
      status = <RenderStatus label="Sem Interesse" />;
    } else if (contato_ok === 1) {
      status = <RenderStatus label="Pré - Chamado" texto={chamadotexto} />;
    } else if (contato_recado === 1) {
      status = (
        <RenderStatus label="Pré - Recado" texto={contato_recadotexto} />
      );
    } else if (contato_natende === 1) {
      status = <RenderStatus label="Não Atende" />;
    } else if (contato_email === 1) {
      status = <RenderStatus label="E-mail" />;
    } else if (contato_sms === 1) {
      status = <RenderStatus label="SMS" />;
    } else if (contato_stelefone === 1) {
      status = <RenderStatus label="Sem Telefone" />;
    } else if (contato_trabalhando === 1) {
      status = <RenderStatus label="Trabalhando" />;
    } else if (contato_semperfil === 1) {
      status = <RenderStatus label="Sem Perfil" texto={contato_recadotexto} />;
    } else {
      status = <RenderStatus label="Pré-entrevista" />;
    }
  }

  // Caso nenhum dos status seja atendido, retorna null
  return status;
};

export default RenderChamado;
